import { useContext } from 'react';

import { ExperimentalDesignSystemContext } from '../../contexts/experimental-design-system';

/**
 * Whether branded glyphs replace lucide icons app-wide. `DesignSystemProvider`
 * reads the flag once and injects it here via context — never a flag hook
 * per icon (~2,000 render sites).
 */
export function useIsBrandedIcons(): boolean {
  return useContext(ExperimentalDesignSystemContext).isBrandedIcons ?? false;
}
